export const getFromLocalstorage = (key: string, fallback: any = undefined): any => {
  try {
    const value = localStorage.getItem(key);
    if (!value) {
      return fallback;
    }

    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const setToLocalstorage = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeFromLocalstorage = (key: string): void => {
  localStorage.removeItem(key);
};
